import { render, staticRenderFns } from "./SizeSelectorAntV.vue?vue&type=template&id=1c969ef5&scoped=true&"
import script from "./SizeSelectorAntV.vue?vue&type=script&lang=js&"
export * from "./SizeSelectorAntV.vue?vue&type=script&lang=js&"
import style0 from "./SizeSelectorAntV.vue?vue&type=style&index=0&id=1c969ef5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c969ef5",
  null
  
)

export default component.exports